import { campaignDay, localDate, type CalendarSpec } from '@somnhold/protocol';
import { setDruidSeason } from '@somnhold/render';

/**
 * The druid's last look blooms by the season of the campaign's own date (docs/sendas/druida.md §10), not the device's:
 * day 0 is the creation day in the group's zone, and an accelerated campaign (`dayMs`) walks its days at its own pace.
 * Render only: the sim never sees it. 0 spring, 1 summer, 2 autumn, 3 winter (the meteorological ones of the north,
 * the path's own year).
 */
export const druidSeasonOf = (cal: CalendarSpec, now: number): number => {
  const d0 = localDate(cal.createdAt, cal.timezone);
  const m = new Date(Date.UTC(d0.y, d0.m, d0.d + campaignDay(cal, now))).getUTCMonth();
  return m >= 2 && m <= 4 ? 0 : m >= 5 && m <= 7 ? 1 : m >= 8 && m <= 10 ? 2 : 3;
};

/** Sets the druid's season from the campaign (called with each state, so a campaign that crosses into a new season blooms anew). */
export const syncDruidSeason = (svc: { calendar(): CalendarSpec; now(): number }): void => setDruidSeason(druidSeasonOf(svc.calendar(), svc.now()));
